import { render, staticRenderFns } from "./CapturaDocumentosFotoVerso.vue?vue&type=template&id=b02eae44&scoped=true&"
import script from "./CapturaDocumentosFotoVerso.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFotoVerso.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFotoVerso.vue?vue&type=style&index=0&id=b02eae44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02eae44",
  null
  
)

export default component.exports